/**
 * Legacy: normalize old div-based promoted blocks into compact embed markup.
 * Modern embeds use <a class="promoted-article-preview cms-promoted-article" data-cms-embed="promoted-article"> — those are left unchanged.
 */
export function processPromotedArticles(htmlContent: string): string {
  const tempDiv = document.createElement("div")
  tempDiv.innerHTML = htmlContent

  const promotedEls = tempDiv.querySelectorAll(".promoted-article-preview")

  promotedEls.forEach((el) => {
    // Keep anchor embeds from the editor / API intact (clickable, compact CSS on site)
    if (el.tagName === "A") return

    const articleId = el.getAttribute("data-article-id")
    const slug = el.getAttribute("data-article-slug") || ""
    const title = el.getAttribute("data-article-title") || ""
    const image = el.getAttribute("data-article-image") || ""
    const readTime = parseInt(el.getAttribute("data-article-read-time") || "0", 10)
    const date = el.getAttribute("data-article-date") || ""
    const excerpt = el.getAttribute("data-article-excerpt") || ""

    if (!articleId) return

    const esc = (s: string) =>
      s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;")
    const titleH = esc(title)
    const excerptP = excerpt.trim() ? `<p class="cms-promoted-excerpt">${esc(excerpt.trim())}</p>` : ""

    const placeholder = document.createElement("div")
    placeholder.className = "promoted-article-wrapper"
    placeholder.setAttribute("data-cms-embed", "promoted-article")
    placeholder.setAttribute("data-promoted-id", articleId)
    placeholder.setAttribute("data-slug", slug)
    placeholder.setAttribute("data-title", title)
    placeholder.setAttribute("data-image", image)
    placeholder.setAttribute("data-read-time", String(readTime))
    placeholder.setAttribute("data-date", date)
    placeholder.innerHTML = `
      <div class="cms-promoted-inner">
        <div class="cms-promoted-thumb">
          ${
            image
              ? `<img src="${esc(image)}" alt="${titleH}" />`
              : `<div style="width:100%;height:100%;display:flex;align-items:center;justify-content:center;font-size:0.65rem;color:#64748b;">No img</div>`
          }
        </div>
        <div class="cms-promoted-body">
          <h4 class="cms-promoted-title">${titleH}</h4>
          ${excerptP}
          <div class="cms-promoted-meta">
            ${readTime ? `<span>${readTime} min read</span>` : ""}
            ${date ? `<span>${esc(new Date(date).toLocaleDateString())}</span>` : ""}
          </div>
        </div>
      </div>
    `
    el.replaceWith(placeholder)
  })

  return tempDiv.innerHTML
}

